import ModalPropertyNoSeason from './components/modal-property-no-season.component';

const Modals = () => {
  return <ModalPropertyNoSeason />;
};

export default Modals;
